import { get } from '@va/http-client';

export const getExternalDashboardScript = (platform) => {
  const url = `/dashboard/js`;

  return get(url, { platform: platform }, {});
};
